fragment EmailDeliverabilityFragment on DeliverabilityStatus {
    status
    unsubscribeStats {
        unsubscribeTime
        unsubscribeSource
        userUnsubscribedBy {
            id
            name
        }
    }
}
